import angular from 'angular';
import FormValidationService from './formValidation.service';

let formValidationModule = angular.module('formValidation', []).service('formValidationService', FormValidationService);

export default formValidationModule;



// WEBPACK FOOTER //
// ./app/common/formValidation/formValidation.js